/**
 * Labstep
 *
 * @desc ShowEdit component for MolecularFormula
 */

import { fieldMolecularFormula } from 'labstep-web/components/PubChemMetadata/Form/fields';
import { PubChemMetadataFormShowEditGeneric } from 'labstep-web/components/PubChemMetadata/Form/ShowEdit/Generic';
import type React from 'react';
import type { IPubChemMetadataFormShowEditMolecularFormulaProps } from './types';

export const PubChemMetadataFormShowEditMolecularFormula: React.FC<
  IPubChemMetadataFormShowEditMolecularFormulaProps
> = ({ parent, pubChemMetadata }) => (
  <PubChemMetadataFormShowEditGeneric
    pubChemMetadata={pubChemMetadata}
    parent={parent}
    field={fieldMolecularFormula}
  />
);
